import moment from 'moment'
import { FLIGHTS_MAX_LEAD_TIME_DAYS } from 'constants/flight'

/**
 * Airlines only support booking flights inside the shared maximum flight lead-time.
 * Keep this check separate from feeder-price availability: unavailable inventory
 * inside the booking window must retain the standard feeder messaging.
 */
export function isCharterDepartureOutOfSystemRange(
  charterDepartureDate: string | undefined,
  currentDate: Date = new Date(),
): boolean {
  if (!charterDepartureDate) return false

  return moment(charterDepartureDate).isSameOrAfter(
    moment(currentDate).add(FLIGHTS_MAX_LEAD_TIME_DAYS, 'days'),
    'day',
  )
}
